module.exports = __webpack_public_path__ + "img/barea.553e1e93.png";